module.exports = __webpack_public_path__ + "img/51.5.COD.66bbf537.png";